var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http:wwww3org1999/xlink",
    viewBox: "0 0 1921.5 665.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1,\r\n      .cls-10,\r\n      .cls-11,\r\n      .cls-12,\r\n      .cls-15,\r\n      .cls-19,\r\n      .cls-20,\r\n      .cls-3,\r\n      .cls-4,\r\n      .cls-5,\r\n      .cls-8 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #ccc;\r\n      }\r\n\r\n      .cls-10,\r\n      .cls-11,\r\n      .cls-12,\r\n      .cls-15,\r\n      .cls-19,\r\n      .cls-20,\r\n      .cls-21,\r\n      .cls-3,\r\n      .cls-4,\r\n      .cls-5,\r\n      .cls-8 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-10,\r\n      .cls-11,\r\n      .cls-12,\r\n      .cls-3,\r\n      .cls-4,\r\n      .cls-5,\r\n      .cls-8 {\r\n        stroke-width: 0.5px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: #25bccd;\r\n      }\r\n\r\n      .cls-4,\r\n      .cls-5,\r\n      .cls-6 {\r\n        opacity: 0.4;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke: #9fa9aa;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #ccc;\r\n      }\r\n\r\n      .cls-6,\r\n      .cls-7 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .cls-17,\r\n      .cls-7 {\r\n        fill: #087988;\r\n      }\r\n\r\n      .cls-7 {\r\n        opacity: 0.19;\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke: #999;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #999;\r\n      }\r\n\r\n      .cls-10 {\r\n        stroke: #b3b3b3;\r\n      }\r\n\r\n      .cls-11,\r\n      .cls-12,\r\n      .cls-15,\r\n      .cls-21 {\r\n        stroke: #087988;\r\n      }\r\n\r\n      .cls-12,\r\n      .cls-13 {\r\n        opacity: 0.5;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #175a68;\r\n      }\r\n\r\n      .cls-15,\r\n      .cls-21 {\r\n        stroke-width: 0.75px;\r\n      }\r\n\r\n      .cls-16,\r\n      .cls-18 {\r\n        opacity: 0.15;\r\n      }\r\n\r\n      .cls-18 {\r\n        mix-blend-mode: soft-light;\r\n      }\r\n\r\n      .cls-19,\r\n      .cls-20 {\r\n        stroke: #494949;\r\n      }\r\n\r\n      .cls-20 {\r\n        stroke-width: 13px;\r\n        stroke-dasharray: 0.2 4;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #323b3f;\r\n      }\r\n\r\n      .cls-23 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-25 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-27 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1065.53,334.51l12.16,17.25a3.53,3.53,0,0,1,.63,2,3.92,3.92,0,0,1-.63,2.1l-12.34,17.41h5.29l10.58-15a7.47,7.47,0,0,0,1.43-4.55,7.38,7.38,0,0,0-1.43-4.5l-10.46-14.74Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1520.49,
    y1: 6026.69,
    x2: -1519.86,
    y2: 6026.69,
    gradientTransform: "translate(42846.42 -165251.89) scale(27.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1bbed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#04b6c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#018493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#036574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015866"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M975.21,334.51l-10.59,15a7.92,7.92,0,0,0,0,9l10.47,14.74h5.23L968.16,356a3.48,3.48,0,0,1-.63-2,4,4,0,0,1,.63-2.11l12.34-17.4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1665.97,
    y1: 6402.93,
    x2: -1665.34,
    y2: 6402.93,
    gradientTransform: "translate(-44798.1 176298.01) rotate(180) scale(27.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.19,369.63a2.41,2.41,0,1,0,2.41-2.4,2.41,2.41,0,0,0-2.41,2.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1319.65,
    y1: 6892.77,
    x2: -1319.02,
    y2: 6892.77,
    gradientTransform: "matrix(7.64, 0, 0, -7.64, 10960.15, 53018.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1bbed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#00a3b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#008d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008393"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loading") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "422.83 345.51 417.7 345.51 415.13 349.96 417.7 354.41 422.83 354.41 425.4 349.96 422.83 345.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "923.45 187.39 913.63 187.39 908.72 195.89 913.63 204.4 923.45 204.4 928.36 195.89 923.45 187.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "682.84 145 648.34 145 631.09 174.88 648.34 204.76 682.84 204.76 700.1 174.88 682.84 145"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "741.28 147.27 732.6 147.27 728.26 154.79 732.6 162.31 741.28 162.31 745.63 154.79 741.28 147.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "745.15 236.53 736.06 236.53 731.52 244.4 736.06 252.27 745.15 252.27 749.69 244.4 745.15 236.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "851.13 462.5 835.22 462.5 827.26 476.29 835.22 490.07 851.13 490.07 859.09 476.29 851.13 462.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "899.74 466.17 881.12 466.17 871.81 482.3 881.12 498.43 899.74 498.43 909.05 482.3 899.74 466.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "779.78 362.15 757.15 362.15 745.84 381.75 757.15 401.35 779.78 401.35 791.09 381.75 779.78 362.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "538.77 396.48 517.28 396.48 506.53 415.09 517.28 433.7 538.77 433.7 549.52 415.09 538.77 396.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "581.84 355.91 574.63 355.91 571.03 362.15 574.63 368.4 581.84 368.4 585.45 362.15 581.84 355.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "677.6 511.01 670.29 511.01 666.64 517.34 670.29 523.67 677.6 523.67 681.25 517.34 677.6 511.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "480.05 553.29 471.91 553.29 467.84 560.34 471.91 567.39 480.05 567.39 484.12 560.34 480.05 553.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "728.57 572.21 723.49 572.21 720.94 576.61 723.49 581.01 728.57 581.01 731.11 576.61 728.57 572.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "504.84 129.65 501.36 129.65 499.61 132.67 501.36 135.69 504.84 135.69 506.59 132.67 504.84 129.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "840.89 28.3 833.45 28.3 829.72 34.74 833.45 41.19 840.89 41.19 844.61 34.74 840.89 28.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "938.28 65.99 934.58 65.99 932.73 69.2 934.58 72.41 938.28 72.41 940.13 69.2 938.28 65.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1015.91 548.23 1001.93 548.23 994.93 560.34 1001.93 572.45 1015.91 572.45 1022.9 560.34 1015.91 548.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1013.8 84.75 975.15 84.75 955.83 118.22 975.15 151.68 1013.8 151.68 1033.12 118.22 1013.8 84.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1104.07 129.3 1092.58 129.3 1086.84 139.25 1092.58 149.2 1104.07 149.2 1109.82 139.25 1104.07 129.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1071.58 0.25 1066.45 0.25 1063.89 4.69 1066.45 9.13 1071.58 9.13 1074.14 4.69 1071.58 0.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "649.32 652.89 646.04 652.89 644.4 655.73 646.04 658.57 649.32 658.57 650.96 655.73 649.32 652.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1232.99 163.18 1223.86 163.18 1219.29 171.09 1223.86 179.01 1232.99 179.01 1237.56 171.09 1232.99 163.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1283.14 83.89 1276.4 83.89 1273.03 89.72 1276.4 95.56 1283.14 95.56 1286.51 89.72 1283.14 83.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1445.56 30.51 1440.67 30.51 1438.23 34.74 1440.67 38.98 1445.56 38.98 1448 34.74 1445.56 30.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1249.19 502.81 1238.12 502.81 1232.58 512.4 1238.12 521.99 1249.19 521.99 1254.73 512.4 1249.19 502.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1232.85 601.05 1224 601.05 1219.57 608.72 1224 616.39 1232.85 616.39 1237.28 608.72 1232.85 601.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1110.8 470.94 1083.38 470.94 1069.67 494.69 1083.38 518.43 1110.8 518.43 1124.5 494.69 1110.8 470.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1165.27 559.98 1156.72 559.98 1152.44 567.39 1156.72 574.8 1165.27 574.8 1169.55 567.39 1165.27 559.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1361.87 621.45 1356.24 621.45 1353.43 626.32 1356.24 631.19 1361.87 631.19 1364.68 626.32 1361.87 621.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1048.14 646.18 1037.11 646.18 1031.6 655.73 1037.11 665.28 1048.14 665.28 1053.65 655.73 1048.14 646.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "907.5 658.85 904.11 658.85 902.41 661.78 904.11 664.72 907.5 664.72 909.19 661.78 907.5 658.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "793.36 195.34 654 195.34 633.82 175.16 484.5 175.16 484.5 177.48 612.5 177.48 633.68 198.66 794.36 198.66 793.36 195.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "789.08 276.2 680.84 276.2 672.5 284.54 511.84 284.54 493.84 302.54 480.84 302.54 478.34 305.04 508.17 305.04 525.09 288.12 720.02 288.12 729.66 278.48 793.36 278.48 789.08 276.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "629.46 206.75 724.16 206.75 726 208.6 623.33 208.6 605.64 190.91 539.16 190.91 536.98 188.73 612.33 188.73 629.46 206.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "484.5 267.78 484.5 271.78 621.5 271.78 625.5 267.78 484.5 267.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "690.81 291.93 569.76 291.93 565.5 296.19 686.64 296.19 690.81 291.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "654.65 186.6 671.16 186.6 675.42 190.86 658.81 190.86 654.65 186.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "921.21 293.57 1060.57 293.57 1080.75 313.75 1230.07 313.75 1230.07 311.43 1102.07 311.43 1080.89 290.25 920.21 290.25 921.21 293.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "929.58 197.9 1037.82 197.9 1046.15 189.57 1206.82 189.57 1224.82 171.57 1237.82 171.57 1240.32 169.07 1210.48 169.07 1193.57 185.98 998.64 185.98 988.99 195.63 925.29 195.63 929.58 197.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1089.2 267.35 994.5 267.35 992.65 265.51 1095.33 265.51 1113.02 283.2 1179.5 283.2 1181.67 285.38 1106.33 285.38 1089.2 267.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1234.15 206.33 1234.15 202.32 1097.15 202.32 1093.15 206.33 1234.15 206.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1027.85 182.17 1148.89 182.17 1153.15 177.91 1032.01 177.91 1027.85 182.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1064.01 287.51 1047.5 287.51 1043.23 283.25 1059.84 283.25 1064.01 287.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "645.8 330.65 632.12 344.34 510.67 344.34 521.6 333.41 521.6 341.4 631.16 341.4 641.91 330.65 645.8 330.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "420.26 243.66 567.61 243.66 605.78 281.83 605.78 268.32 601.4 272.69 569.61 240.91 420.26 240.91 420.26 243.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1271.8 384.72 1285.48 371.04 1406.92 371.04 1396 381.97 1396 373.97 1286.44 373.97 1275.69 384.72 1271.8 384.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1495.83 473.21 1348.49 473.21 1310.32 435.04 1310.32 448.56 1314.7 444.18 1346.48 475.97 1495.83 475.97 1495.83 473.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "828.02 331.63 652.64 331.63 635.3 348.97 507.5 348.97 449.41 290.88 410 290.88 1 290.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "834.14 390.2 747.21 390.2 672.1 465.3 493.57 465.3 471.14 487.73 410 487.73 1 487.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 840.16,
    y1: 408.6,
    x2: 728.8,
    y2: 408.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M652.89,256.86l-9.78-9.77H1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "655.98 259.71 655.44 254.01 652.86 256.59 650.28 259.17 655.98 259.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "506.26 371.7 510.67 375.35 510.67 371.7 510.67 368.05 506.26 371.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "825.08 366.82 700.29 366.82 678.58 388.53 641.16 388.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M642.4,388.47a2.29,2.29,0,1,1-2.29-2.28A2.29,2.29,0,0,1,642.4,388.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M550.28,229.93a2.29,2.29,0,1,1-2.29-2.29A2.29,2.29,0,0,1,550.28,229.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M538.77,492.4a2.29,2.29,0,1,1-2.29-2.29A2.29,2.29,0,0,1,538.77,492.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 536.48,
    cy: 492.4,
    r: 39.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 547.99,
    cy: 229.93,
    r: 26.95,
    transform: "translate(36.41 532.33) rotate(-53.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M554.5,445.68a2.29,2.29,0,1,1-2.29-2.29A2.29,2.29,0,0,1,554.5,445.68Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "552.21 445.68 482.15 445.68 451.54 476.29 410 476.29 0 476.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "828.05 306.71 624.77 306.71 547.99 229.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "862.82 436.23 646.78 436.23 590.6 492.4 538.29 492.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "846.41 272.99 620.24 272.99 605.64 287.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "820.51 357.53 693.94 357.53 679.76 371.7 510.67 371.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "704.95 457.97 699.25 458.51 701.83 461.09 704.41 463.67 704.95 457.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "519.33 482.21 680.64 482.21 701.79 461.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1089.58 383.75 1264.96 383.75 1282.3 366.41 1410.1 366.41 1468.19 424.5 1507.6 424.5 1921.5 424.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1083.45 325.18 1170.39 325.18 1245.49 250.07 1424.03 250.07 1446.45 227.65 1511.26 227.65 1921 227.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1077.44,
    y1: 306.77,
    x2: 1188.8,
    y2: 306.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1219.1,477.37l9.77,9.78H1921.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1216.01 474.52 1216.55 480.23 1219.13 477.64 1221.71 475.06 1216.01 474.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1411.33 343.67 1406.92 340.02 1406.92 343.67 1406.92 347.32 1411.33 343.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1092.52 348.56 1217.31 348.56 1239.02 326.85 1276.44 326.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1275.2,326.9a2.29,2.29,0,1,1,2.29,2.29A2.28,2.28,0,0,1,1275.2,326.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1365.82,487a2.29,2.29,0,1,1,2.28,2.28A2.28,2.28,0,0,1,1365.82,487Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1378.83,223a2.29,2.29,0,1,1,2.28,2.28A2.28,2.28,0,0,1,1378.83,223Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1380.77,
    cy: 223.2,
    r: 39.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1368.1,
    cy: 486.95,
    r: 26.95,
    transform: "translate(-82.53 553.94) rotate(-22.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1363.1,269.7a2.29,2.29,0,1,1,2.28,2.28A2.28,2.28,0,0,1,1363.1,269.7Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1365.38 269.7 1435.45 269.7 1466.06 239.09 1508.33 239.09 1921 239.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1089.55 408.67 1292.83 408.67 1369.6 485.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1054.78 279.15 1270.82 279.15 1326.99 222.98 1379.31 222.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1071.19 442.39 1297.36 442.39 1311.95 427.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1097.09 357.85 1223.66 357.85 1237.83 343.67 1406.92 343.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1212.65 257.41 1218.35 256.87 1215.77 254.29 1213.19 251.71 1212.65 257.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1398.27 233.17 1236.96 233.17 1215.81 254.32"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 960.52,
    cy: 349.96,
    r: 178.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 960.52,
    cy: 349.96,
    r: 240.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1176.55,211.48a256.88,256.88,0,0,1,10.73,258.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M766.07,517.34a256.6,256.6,0,0,1,50.17-379.57"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M783.34,493.44a1.48,1.48,0,0,1,.22-2.06h0a1.47,1.47,0,0,1,2.07.22h0a1.47,1.47,0,0,1-.22,2.06h0a1.44,1.44,0,0,1-.92.33h0A1.53,1.53,0,0,1,783.34,493.44Zm-8.91-11.76a1.45,1.45,0,0,1,.35-2h0a1.47,1.47,0,0,1,2,.33h0a1.48,1.48,0,0,1-.35,2.06h0a1.49,1.49,0,0,1-.84.26h0A1.42,1.42,0,0,1,774.43,481.68Zm-8.14-12.3a1.49,1.49,0,0,1,.47-2h0a1.48,1.48,0,0,1,2,.49h0a1.46,1.46,0,0,1-.49,2h0a1.49,1.49,0,0,1-.76.22h0A1.45,1.45,0,0,1,766.29,469.38ZM759,456.58a1.45,1.45,0,0,1,.62-2h0a1.46,1.46,0,0,1,2,.6h0a1.46,1.46,0,0,1-.62,2h0a1.53,1.53,0,0,1-.69.17h0A1.47,1.47,0,0,1,759,456.58Zm-6.48-13.25a1.47,1.47,0,0,1,.74-1.93h0a1.49,1.49,0,0,1,1.95.73h0a1.48,1.48,0,0,1-.75,1.95h0a1.4,1.4,0,0,1-.6.12h0A1.48,1.48,0,0,1,752.48,443.33Zm395.7-217.63a1.48,1.48,0,0,1,.41-2h0a1.48,1.48,0,0,1,2,.41h0a1.48,1.48,0,0,1-.41,2h0a1.46,1.46,0,0,1-.82.25h0A1.46,1.46,0,0,1,1148.18,225.7Zm-8.43-11.87a1.44,1.44,0,0,1,.28-2.05h0a1.46,1.46,0,0,1,2,.28h0a1.46,1.46,0,0,1-.28,2.05h0a1.48,1.48,0,0,1-.89.31h0A1.45,1.45,0,0,1,1139.75,213.83Zm-9.19-11.3h0a1.45,1.45,0,0,1,.15-2.07h0a1.46,1.46,0,0,1,2.06.14h0a1.48,1.48,0,0,1-.14,2.07h0a1.49,1.49,0,0,1-1,.35h0A1.43,1.43,0,0,1,1130.56,202.53Zm-9.91-10.69a1.49,1.49,0,0,1,0-2.08h0a1.49,1.49,0,0,1,2.08,0h0a1.47,1.47,0,0,1,0,2.08h0a1.49,1.49,0,0,1-1,.43h0A1.49,1.49,0,0,1,1120.65,191.84Zm-10.56-10.05a1.46,1.46,0,0,1-.13-2.06h0a1.48,1.48,0,0,1,2.08-.12h0a1.48,1.48,0,0,1,.12,2.07h0a1.49,1.49,0,0,1-1.1.5h0A1.46,1.46,0,0,1,1110.09,181.79Zm-296.19-4.5a1.46,1.46,0,0,1,.17-2.06h0a1.47,1.47,0,0,1,2.07.17h0a1.46,1.46,0,0,1-.18,2.07h0a1.44,1.44,0,0,1-.93.34h0A1.47,1.47,0,0,1,813.9,177.29Zm285-4.83h0a1.48,1.48,0,0,1-.25-2.07h0a1.47,1.47,0,0,1,2-.25h0a1.47,1.47,0,0,1,.26,2.06h0a1.43,1.43,0,0,1-1.16.57h0A1.42,1.42,0,0,1,1098.89,172.46Zm-273.53-4.3a1.47,1.47,0,0,1,.32-2h0a1.47,1.47,0,0,1,2.06.32h0a1.47,1.47,0,0,1-.32,2h0a1.49,1.49,0,0,1-.87.29h0A1.47,1.47,0,0,1,825.36,168.16Zm261.76-4.3h0a1.43,1.43,0,0,1-.38-2h0a1.45,1.45,0,0,1,2-.38h0a1.47,1.47,0,0,1,.38,2h0a1.5,1.5,0,0,1-1.22.65h0A1.41,1.41,0,0,1,1087.12,163.86ZM837.4,159.79a1.45,1.45,0,0,1,.45-2h0a1.47,1.47,0,0,1,2,.44h0a1.47,1.47,0,0,1-.46,2h0a1.37,1.37,0,0,1-.78.23h0A1.46,1.46,0,0,1,837.4,159.79Zm237.4-3.74h0a1.48,1.48,0,0,1-.51-2h0a1.47,1.47,0,0,1,2-.51h0a1.46,1.46,0,0,1,.51,2h0a1.47,1.47,0,0,1-1.26.72h0A1.6,1.6,0,0,1,1074.8,156.05ZM850,152.21a1.48,1.48,0,0,1,.57-2h0a1.47,1.47,0,0,1,2,.59h0a1.47,1.47,0,0,1-.57,2h0a1.64,1.64,0,0,1-.7.17h0A1.46,1.46,0,0,1,850,152.21ZM1062,149h0a1.46,1.46,0,0,1-.65-2h0a1.47,1.47,0,0,1,2-.66h0a1.46,1.46,0,0,1,.64,2h0a1.45,1.45,0,0,1-1.3.8h0A1.56,1.56,0,0,1,1062,149ZM863,145.47a1.47,1.47,0,0,1,.71-1.95h0a1.47,1.47,0,0,1,2,.7h0a1.46,1.46,0,0,1-.71,1.95h0a1.36,1.36,0,0,1-.61.14h0A1.46,1.46,0,0,1,863,145.47Zm185.85-2.59A1.46,1.46,0,0,1,1048,141h0a1.46,1.46,0,0,1,1.92-.77h0a1.46,1.46,0,0,1,.78,1.92h0a1.48,1.48,0,0,1-1.35.89h0A1.46,1.46,0,0,1,1048.8,142.88Zm-172.43-3.29a1.48,1.48,0,0,1,.82-1.91h0a1.47,1.47,0,0,1,1.9.84h0a1.47,1.47,0,0,1-.82,1.9h0a1.77,1.77,0,0,1-.54.1h0A1.46,1.46,0,0,1,876.37,139.59Zm158.82-2a1.45,1.45,0,0,1-.89-1.86h0a1.46,1.46,0,0,1,1.87-.91h0a1.49,1.49,0,0,1,.9,1.88h0a1.49,1.49,0,0,1-1.4,1h0A1.36,1.36,0,0,1,1035.19,137.59Zm-145-3a1.46,1.46,0,0,1,1-1.85h0a1.47,1.47,0,0,1,1.85.95h0a1.48,1.48,0,0,1-1,1.85h0a1.72,1.72,0,0,1-.44.06h0A1.48,1.48,0,0,1,890.15,134.59Zm131.14-1.38a1.46,1.46,0,0,1-1-1.81h0a1.47,1.47,0,0,1,1.8-1h0a1.47,1.47,0,0,1,1,1.81h0a1.49,1.49,0,0,1-1.42,1.07h0A1.44,1.44,0,0,1,1021.29,133.21Zm-117-2.73a1.45,1.45,0,0,1,1.07-1.77h0a1.47,1.47,0,0,1,1.77,1.07h0a1.46,1.46,0,0,1-1.07,1.77h0a1.41,1.41,0,0,1-.35,0h0A1.45,1.45,0,0,1,904.24,130.48Zm102.9-.73A1.47,1.47,0,0,1,1006,128h0a1.46,1.46,0,0,1,1.73-1.13h0a1.47,1.47,0,0,1,1.14,1.73h0a1.47,1.47,0,0,1-1.44,1.18h0Zm-88.58-2.44a1.47,1.47,0,0,1,1.17-1.7h0a1.47,1.47,0,0,1,1.71,1.19h0a1.47,1.47,0,0,1-1.18,1.7h0a1.09,1.09,0,0,1-.26,0h0A1.46,1.46,0,0,1,918.56,127.31Zm74.24-.1h0a1.46,1.46,0,0,1-1.24-1.65h0a1.46,1.46,0,0,1,1.66-1.25h0a1.46,1.46,0,0,1,1.24,1.66h0a1.46,1.46,0,0,1-1.45,1.26h0Zm-59.75-2.12a1.47,1.47,0,0,1,1.29-1.63h0a1.48,1.48,0,0,1,1.62,1.3h0a1.46,1.46,0,0,1-1.29,1.62h-.17A1.48,1.48,0,0,1,933.05,125.09Zm45.27.51A1.46,1.46,0,0,1,977,124h0a1.46,1.46,0,0,1,1.57-1.35h0a1.45,1.45,0,0,1,1.35,1.57h0a1.47,1.47,0,0,1-1.45,1.36h-.12Zm-30.67-1.8a1.48,1.48,0,0,1,1.39-1.54h0a1.47,1.47,0,0,1,1.54,1.39h0a1.47,1.47,0,0,1-1.39,1.54h-.07A1.46,1.46,0,0,1,947.65,123.8Zm16.11,1.14h0a1.49,1.49,0,0,1-1.44-1.5h0a1.45,1.45,0,0,1,1.49-1.43h0a1.44,1.44,0,0,1,1.43,1.48h0a1.46,1.46,0,0,1-1.45,1.45h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M856.93,529.62A208.66,208.66,0,0,1,759.57,401.3l76.72-19.55a129,129,0,0,0,60.23,79.32Zm248.43-31.26-55.3-56.66A127.2,127.2,0,0,0,1088.72,350v-.37h79.17V350A205.79,205.79,0,0,1,1105.36,498.36ZM896.28,239l-39.74-68.47a207.81,207.81,0,0,1,159.78-20.32l-21.27,76.26A128.65,128.65,0,0,0,896.28,239Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M796.37,514.76l8.3-8.3A222.59,222.59,0,0,0,890,559.62l-3.77,11.1A234.49,234.49,0,0,1,796.37,514.76ZM1182.62,350A219.25,219.25,0,0,0,1160,252.28l10.52-5.18a230.83,230.83,0,0,1,23.86,102.81v.31h-11.73Zm-442-75.43a234.31,234.31,0,0,1,56.12-89.72l8.27,8.31a222.46,222.46,0,0,0-53.29,85.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1081.18,159l-6.07,9.66a216.52,216.52,0,0,0-92.44-31.79l1.17-11.35A228,228,0,0,1,1081.18,159ZM938.69,565.26l-1.16,11.35a227.93,227.93,0,0,1-97.37-33.37l6.05-9.67A216.42,216.42,0,0,0,938.69,565.26Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 960.52,
    cy: 349.96,
    r: 196.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 1187.27,
    cy: 470.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 1176.55,
    cy: 211.48,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 816.24,
    cy: 137.77,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 766.26,
    cy: 517.34,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 959.79,
    cy: 349.22,
    r: 143.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M902.54,325.76c-.51,0-.8.22-.8.74v46.76h-4.26V326.49a.66.66,0,0,0-.74-.74h-8.31v-4.33h22.42v4.33h-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M945.75,339.58a19.28,19.28,0,0,1,5.86,14.16v2.16H916.74c-.57,0-.74.29-.68.75a15.73,15.73,0,0,0,15.47,12.85A15.78,15.78,0,0,0,946.1,360h4.55a19.81,19.81,0,0,1-7.33,10,19.45,19.45,0,0,1-11.77,3.8,20.08,20.08,0,1,1,14.2-34.24m-24.3,2a15.42,15.42,0,0,0-5.4,9.22c0,.57.12.8.68.8h29.64c.51,0,.74-.23.68-.8a15.14,15.14,0,0,0-5.46-9.22,15.78,15.78,0,0,0-20.14,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 957.06,
    y: 321.43,
    width: 4.33,
    height: 51.83
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1065.35,
    y: 334.51,
    width: 17.3,
    height: 38.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 963.2,
    y: 334.51,
    width: 17.3,
    height: 38.75
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1057,339.58a20,20,0,1,1-29.4,27.18c-.06-.11-.23-.17-.46-.11s-.17.17-.17.28v19.46h-4.21V353.46a18.76,18.76,0,0,1,5.86-13.94,20,20,0,0,1,28.38.06m-25.42,3a15.78,15.78,0,0,0,11.2,27,15.78,15.78,0,1,0-11.2-27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1013,321.43v36.8a11.24,11.24,0,1,1-22.47,0V334.51h-4.21v23.72a15.42,15.42,0,0,0,26.35,11,15,15,0,0,0,4.55-11v-36.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 880.19,
    y: 367.23,
    width: 4.81,
    height: 4.81
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M858.72,374.11a19.39,19.39,0,0,1-14.16-5.85,18.8,18.8,0,0,1-5.86-13.95V321.37h4.21v19.46c0,.11.06.17.17.28s.4,0,.46-.11a20,20,0,1,1,29.4,27.18,19.19,19.19,0,0,1-14.22,5.93m0-4.27a15.79,15.79,0,1,0,0-31.57A15.71,15.71,0,0,0,842.91,354a15.43,15.43,0,0,0,4.6,11.21,15.27,15.27,0,0,0,11.21,4.6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2f996eaa.svg";
export { ForwardRef as ReactComponent };